/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpResponse } from '@angular/common/http';
import {KeyValueLongString} from '../model/keyValueLongString';
import {KeyValueStringString} from '../model/keyValueStringString';
import {Observable} from 'rxjs';

import {GetSmtpTemplateOverviewDTO} from '../model/getSmtpTemplateOverviewDTO';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class ConfiguratorSendInBlueService {

    protected basePath = 'https://dmp.airiane.com/services/configurator';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Obtenir une liste de pair (id, label) des templates de emails
     * Cette requête permet d&#x27;obtenir la liste des templates de emails de type transactional.&lt;br&gt;Chaque élément de la liste est un pair (id, label).&lt;br&gt;&lt;b&gt;id :&lt;/b&gt; l&#x27;identifiant du template de email.&lt;br&gt;&lt;b&gt;label :&lt;/b&gt; le label du template de email. Il s&#x27;agit d&#x27;id de l&#x27;email dans SendInBlue, son nom et son état d&#x27;activation.
     * @param xDataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllTransactionalEmails1(xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<Array<KeyValueLongString>>;
    public getAllTransactionalEmails1(xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<KeyValueLongString>>>;
    public getAllTransactionalEmails1(xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<KeyValueLongString>>>;
    public getAllTransactionalEmails1(xDataStoreID: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getAllTransactionalEmails1.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<KeyValueLongString>>('get', `${this.basePath}/api/sib/smtp/templates`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtenir un template de email
     * Cette requête permet d&#x27;obtenir un template de email par son identifiant.&lt;br&gt;Si l&#x27;identifiant correspond à un template de email de type transactional, alors le résultat est un objet de type GetSmtpTemplateOverviewDTO et un code 200.&lt;br&gt;Si non, le code 404 est renvoyé.
     * @param xDataStoreID
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTransactionalEmailsById(xDataStoreID: string, id: number, observe?: 'body', reportProgress?: boolean): Observable<GetSmtpTemplateOverviewDTO>;
    public getTransactionalEmailsById(xDataStoreID: string, id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetSmtpTemplateOverviewDTO>>;
    public getTransactionalEmailsById(xDataStoreID: string, id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetSmtpTemplateOverviewDTO>>;
    public getTransactionalEmailsById(xDataStoreID: string, id: number, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getTransactionalEmailsById.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getTransactionalEmailsById.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetSmtpTemplateOverviewDTO>('get', `${this.basePath}/api/sib/smtp/templates/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtenir la liste des adresses email expéditeurs validées
     * Cette requête permet d&#x27;obtenir la liste des adresses email expéditeurs validées et actives dans Brevo.&lt;br&gt;Chaque élément de la liste est un pair (email, label).&lt;br&gt;&lt;b&gt;email :&lt;/b&gt; l&#x27;adresse email de l&#x27;expéditeur.&lt;br&gt;&lt;b&gt;label :&lt;/b&gt; le label affichable (email + nom si disponible).
     * @param xDataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getValidatedSenders(xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<Array<KeyValueStringString>>;
    public getValidatedSenders(xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<KeyValueStringString>>>;
    public getValidatedSenders(xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<KeyValueStringString>>>;
    public getValidatedSenders(xDataStoreID: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getValidatedSenders.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<KeyValueStringString>>('get', `${this.basePath}/api/sib/senders`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
